import { Component, OnInit } from '@angular/core';
import { UtilService } from 'app/shared/util.service';
import { Hotel } from 'app/shared/model/hotel';
import { DateService } from 'app/shared/services/date.service';
import { Router } from '@angular/router';

@Component({
    selector: 'mh-chain-followup-summary',
    templateUrl: './summary-section.component.html',
    standalone: false
})
export class SummarySectionComponent implements OnInit {
  productId = 1;

  chain: Hotel[] = [];
  chainFilter: Hotel[] = [];
  originalChainFilter: Hotel[] = [];
  isReady = false;
  surveysReady = false;
  loadingWidgets = false;

  report = null;
  reportSlug = 'interchain_followup_summary';

  constructor(private utilService: UtilService, private dateService: DateService, private router: Router) {}

  ngOnInit(): void {
    this.getProductById();
    this.utilService.setGeneralFade(false);
    setTimeout(() => {
      this.chain = this.utilService.getChain(this.utilService.getProductById(this.productId));
    }, 0);
  }

  getProductById(): void {
    this.productId = this.router.url.includes('followup') ? 1 : 2;
  }

  setChain(chain: Hotel[]): void {
    setTimeout(() => {
      this.dataIsReady(chain.length !== 0);
      this.originalChainFilter = [...chain];
      this.chainFilter = [...chain];
    }, 0);
  }

  handleHotelsChange(hotels: Hotel[]): void {
    if (this.loadingWidgets) {
      return;
    }
    this.setHotelsFilter(hotels);
  }

  setHotelsFilter(hotels: Hotel[]): void {
    this.chainFilter = hotels;
  }

  onSurveysLoaded(surveysReady: boolean): void {
    this.surveysReady = !surveysReady;
  }

  dataIsReady(state: boolean): void {
    setTimeout(() => {
      this.isReady = state;
    }, 200);
  }

  handleDatepickerUpdated($event: { currentFilter: unknown; currentDates: unknown }): void {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates);
  }

  onLoadingStateChange(isLoading: boolean): void {
    this.loadingWidgets = isLoading;
  }

  // Getters
  get currentDates(): unknown {
    return this.dateService.currentDates;
  }

  get currentFilterDate(): any {
    return this.dateService.currentFilter;
  }

  get fidelityPermissions(): string[] {
    return this.utilService.getFidelityConfigurationsByProduct('interchain', 'interchain_followup') || [];
  }

  get startDate(): string {
    return this.dateService.currentDates.startDate;
  }

  get endDate(): string {
    return this.dateService.currentDates.endDate;
  }

  get shouldShowSummary(): boolean {
    return (
      this.chainFilter.length > 0 &&
      this.surveysReady &&
      this.isReady &&
      this.fidelityPermissions.includes('interchain_followup_summary_result')
    );
  }

  get isHotelsFilterDisabled(): boolean {
    return !this.isReady || this.originalChainFilter.length === 0 || this.loadingWidgets;
  }

  get shouldShowSurveyWrapper(): boolean {
    return this.chainFilter.length > 0 && this.isReady;
  }
}
